<template>
  <div style="width: 100%;height: 100%">
    <el-scrollbar style="height: 100%;padding-left:3%;">
      <div style="font-size: 26px;font-weight: bolder;margin-left: 47.5%;height: 6%">附件</div>
<!--      <div v-if="!isDisabled" style="margin-left: 41%;height: 6%">(支持上传pdf和图片类型文件)</div>-->
<!--      <div v-if="isDisabled" style="margin-left: 43%;height: 6%">（点击可下载相关附件）</div>-->
      <div style="margin-top: 2%;width: 100%;text-align: left">
        <el-upload
          :disabled="isDisabled"
          class="myUpload"
          :auto-upload="false"
          action="#"
          :on-change="handleChange01"
          :before-remove="beforeRemove"
          :on-remove="handleRemove"
          :on-preview="onPreviewFile"
          :file-list="files01">
          <div v-if="!isDisabled">1.核心知识产权证明，包括论文、专利等；<i class="el-icon-folder-add" style="color:#409EFF ">(点此上传)</i></div>
          <div v-else>1.核心知识产权证明，包括论文、专利等；</div>
        </el-upload>
        <el-upload
          :disabled="isDisabled"
          class="myUpload"
          :auto-upload="false"
          action="#"
          :on-change="handleChange02"
          :before-remove="beforeRemove"
          :on-remove="handleRemove"
          :on-preview="onPreviewFile"
          :file-list="files02">
          <div v-if="!isDisabled">2.第三方评价证明，包括评价证书、检测报告等；<i class="el-icon-folder-add" style="color:#409EFF ">(点此上传)</i></div>
          <div v-else>2.第三方评价证明，包括评价证书、检测报告等；</div>
        </el-upload>
        <el-upload
          :disabled="isDisabled"
          class="myUpload"
          :auto-upload="false"
          action="#"
          :on-change="handleChange03"
          :before-remove="beforeRemove"
          :on-remove="handleRemove"
          :on-preview="onPreviewFile"
          :file-list="files03">
          <div v-if="!isDisabled">3.应用证明；<i class="el-icon-folder-add" style="color:#409EFF ">(点此上传)</i></div>
          <div v-else>3.应用证明；</div>
        </el-upload>
        <el-upload
          :disabled="isDisabled"
          class="myUpload"
          :auto-upload="false"
          action="#"
          :on-change="handleChange04"
          :before-remove="beforeRemove"
          :on-remove="handleRemove"
          :on-preview="onPreviewFile"
          :file-list="files04">
          <div v-if="!isDisabled">4.检索报告（EI、SCI论文须提供）；<i class="el-icon-folder-add" style="color:#409EFF ">(点此上传)</i></div>
          <div v-else>4.检索报告（EI、SCI论文须提供）；</div>
        </el-upload>
        <el-upload
          :disabled="isDisabled"
          class="myUpload"
          :auto-upload="false"
          action="#"
          :on-change="handleChange05"
          :before-remove="beforeRemove"
          :on-remove="handleRemove"
          :on-preview="onPreviewFile"
          :file-list="files05">
          <div v-if="!isDisabled">5.其它证明。<i class="el-icon-folder-add" style="color:#409EFF ">(点此上传)</i></div>
          <div v-else>5.其它证明。</div>
        </el-upload>
      </div>
    </el-scrollbar>
  </div>

</template>

<script>
import utils from "../../js/utils";

export default {
  name: "attachment_12",
  data() {
    return {
      createuserid: sessionStorage.getItem('createuserid'),
      isDisabled: sessionStorage.getItem('openWith')=='readOnly' ? true : false,
      files01: [],
      files02: [],
      files03: [],
      files04: [],
      files05: [],
    }
  },
  methods:{
    getFiles01() {
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/common/selectprojectadjunc',
        params: {
          pbcid: Number(sessionStorage.getItem('pbcid')),
          type: '附件01'
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.files01 = []
          resp.data.forEach(obj => {
            this.files01.push({
              name:obj.adjuntcode+'-'+obj.oldname,
              url: this.getFileUrl(obj.name),
              aid: obj.aid
            })
          })
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    handleChange01(file, fileList) {
      this.$prompt('请输入文件编号', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator:value => {
          if(!value){
            return '文件编号不能为空'
          }
        }
      }).then(({ value }) => {
        this.files01 = fileList
        this.handleUpload01(value)
      }).catch(() => {
        this.getFiles01()
      });

    },
    handleUpload01(adjuntcode) {
      let formData = new FormData()
      this.files01.filter(obj => obj.status == "ready").forEach((obj, index) => {
        formData.append('files', obj.raw)
      })
      formData.append('pbcid', sessionStorage.getItem('pbcid'))
      formData.append('type', '附件01')
      formData.append('adjuntcode', adjuntcode)
      this.$axios({
        method: 'post',
        url: this.GLOBAL.URL + 'pingjiang/file/addfile',
        data: formData
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.showSuccessMsg(resp.message)
          this.getFiles01()
        } else {
          this.showFailMsg(resp.message+',请重新上传')
          this.getFiles01()
        }
      })
    },
    beforeRemove() {
      return this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
    },
    handleRemove(file, fileList) {
      this.$axios({
        method: 'post',
        url: this.GLOBAL.URL + 'pingjiang/file/deletefilelist',
        data: [file.aid],
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.showSuccessMsg(resp.message)
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    handleDownload(file) {
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/file/downloadfile',
        params: {
          aid: file.aid
        },
        responseType: 'blob'
      }).then(res => {
        // const filename = res.headers['content-disposition'].match(/filename=(.*)/)[1]
        const filename = file.name
        const blob = new Blob([res.data]);//处理文档流
        const alink = document.createElement('a');
        alink.style.display = 'none';
        alink.href = window.URL.createObjectURL(blob);
        alink.setAttribute('download', decodeURI(filename))
        document.body.appendChild(alink);
        alink.click();
        window.URL.revokeObjectURL(alink.href); // 释放URL 对象
        document.body.removeChild(alink);
      })
    },

    getFiles02() {
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/common/selectprojectadjunc',
        params: {
          pbcid: Number(sessionStorage.getItem('pbcid')),
          type: '附件02'
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.files02 = []
          resp.data.forEach(obj => {
            this.files02.push({
              name:obj.adjuntcode+'-'+obj.oldname,
              url: this.getFileUrl(obj.name),
              aid: obj.aid
            })
          })
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    handleChange02(file, fileList) {
      this.$prompt('请输入文件编号', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator:value => {
          if(!value){
            return '文件编号不能为空'
          }
        }
      }).then(({ value }) => {
        this.files02 = fileList
        this.handleUpload02(value)
      }).catch(() => {
        this.getFiles02()
      });
    },
    handleUpload02(adjuntcode) {
      let formData = new FormData()
      this.files02.filter(obj => obj.status == "ready").forEach((obj, index) => {
        formData.append('files', obj.raw)
      })
      formData.append('pbcid', sessionStorage.getItem('pbcid'))
      formData.append('type', '附件02')
      formData.append('adjuntcode', adjuntcode)
      this.$axios({
        method: 'post',
        url: this.GLOBAL.URL + 'pingjiang/file/addfile',
        data: formData
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.showSuccessMsg(resp.message)
          this.getFiles02()
        } else {
          this.showFailMsg(resp.message+',请重新上传')
          this.getFiles02()
        }
      })
    },

    getFiles03() {
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/common/selectprojectadjunc',
        params: {
          pbcid: Number(sessionStorage.getItem('pbcid')),
          type: '附件03'
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.files03 = []
          resp.data.forEach(obj => {
            this.files03.push({
              name:obj.adjuntcode+'-'+obj.oldname,
              url: this.getFileUrl(obj.name),
              aid: obj.aid
            })
          })
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    handleChange03(file, fileList) {
      this.$prompt('请输入文件编号', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator:value => {
          if(!value){
            return '文件编号不能为空'
          }
        }
      }).then(({ value }) => {
        this.files03 = fileList
        this.handleUpload03(value)
      }).catch(() => {
        this.getFiles03()
      });
    },
    handleUpload03(adjuntcode) {
      let formData = new FormData()
      this.files03.filter(obj => obj.status == "ready").forEach((obj, index) => {
        formData.append('files', obj.raw)
      })
      formData.append('pbcid', sessionStorage.getItem('pbcid'))
      formData.append('type', '附件03')
      formData.append('adjuntcode', adjuntcode)
      this.$axios({
        method: 'post',
        url: this.GLOBAL.URL + 'pingjiang/file/addfile',
        data: formData
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.showSuccessMsg(resp.message)
          this.getFiles03()
        } else {
          this.showFailMsg(resp.message+',请重新上传')
          this.getFiles03()
        }
      })
    },

    getFiles04() {
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/common/selectprojectadjunc',
        params: {
          pbcid: Number(sessionStorage.getItem('pbcid')),
          type: '附件04'
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.files04 = []
          resp.data.forEach(obj => {
            this.files04.push({
              name:obj.adjuntcode+'-'+obj.oldname,
              url: this.getFileUrl(obj.name),
              aid: obj.aid
            })
          })
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    handleChange04(file, fileList) {
      this.$prompt('请输入文件编号', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator:value => {
          if(!value){
            return '文件编号不能为空'
          }
        }
      }).then(({ value }) => {
        this.files04 = fileList
        this.handleUpload04(value)
      }).catch(() => {
        this.getFiles04()
      });
    },
    handleUpload04(adjuntcode) {
      let formData = new FormData()
      this.files04.filter(obj => obj.status == "ready").forEach((obj, index) => {
        formData.append('files', obj.raw)
      })
      formData.append('pbcid', sessionStorage.getItem('pbcid'))
      formData.append('type', '附件04')
      formData.append('adjuntcode', adjuntcode)
      this.$axios({
        method: 'post',
        url: this.GLOBAL.URL + 'pingjiang/file/addfile',
        data: formData
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.showSuccessMsg(resp.message)
          this.getFiles04()
        } else {
          this.showFailMsg(resp.message+',请重新上传')
          this.getFiles04()
        }
      })
    },

    getFiles05() {
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/common/selectprojectadjunc',
        params: {
          pbcid: Number(sessionStorage.getItem('pbcid')),
          type: '附件05'
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.files05 = []
          resp.data.forEach(obj => {
            this.files05.push({
              name:obj.adjuntcode+'-'+obj.oldname,
              url: this.getFileUrl(obj.name),
              aid: obj.aid
            })
          })
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    handleChange05(file, fileList) {
      this.$prompt('请输入文件编号', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator:value => {
          if(!value){
            return '文件编号不能为空'
          }
        }
      }).then(({ value }) => {
        this.files05 = fileList
        this.handleUpload05(value)
      }).catch(() => {
        this.getFiles05()
      });
    },
    handleUpload05(adjuntcode) {
      let formData = new FormData()
      this.files05.filter(obj => obj.status == "ready").forEach((obj, index) => {
        formData.append('files', obj.raw)
      })
      formData.append('pbcid', sessionStorage.getItem('pbcid'))
      formData.append('type', '附件05')
      formData.append('adjuntcode', adjuntcode)
      this.$axios({
        method: 'post',
        url: this.GLOBAL.URL + 'pingjiang/file/addfile',
        data: formData
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.showSuccessMsg(resp.message)
          this.getFiles05()
        } else {
          this.showFailMsg(resp.message+',请重新上传')
          this.getFiles05()
        }
      })
    },

  },
  created() {
    this.getFiles01()
    this.getFiles02()
    this.getFiles03()
    this.getFiles04()
    this.getFiles05()
  },
  mounted() {
    if(sessionStorage.getItem('pbcid')==undefined){
      this.$message.error('请先填写项目基本情况表');
      this.$router.push({
        path:'/HomePage/PJGLHomepage/projectHomePage/PrimaryInfo_01'
      })
    }
  }

}
</script>

<style scoped>
/deep/ .el-scrollbar__wrap {
  overflow: hidden scroll;
  height: 100%;
}
/deep/ .el-upload{
  text-align: left;
}
@media screen and (min-width: 1295px){
  .myUpload{
    margin-left: 3%;width: 50%
  }
}
@media screen and (max-width: 1295px){
  .myUpload{
    margin-left: 3%;width: 97%
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PJGL/ProjectSequence/attachment_12.vue